module.exports = __webpack_public_path__ + "img/spitter-attack-6.6fad69c2.png";